import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { AppHeaderStates } from "../../../common/enums/AppHeaderStates";
import { BaseApiService } from "../../../common/services/base-api-service";
import { AccountApi } from "../../../common/apis/account-api";
import { BreakpointObserver } from "@angular/cdk/layout";
import { MerchantLoginService } from "../../../common/services/merchant-login.service";
import { AppNavigator, NavigatorTarget } from "../../../services/app-navigator";
import { RedirectService } from "../../../common/services/redirect.service";
import { AuthService } from "../../services/auth.service";


export enum LogoURLs {
  LOGO_ONLY = "/assets/logo-only.svg",
  FULL_LOGO = "/assets/logo-full.svg"
}

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  @Input() headerState!: AppHeaderStates
  formGroup: FormGroup = new FormGroup({});
  switchLanguageName: string = ""
  switchLanguageImageURL: string = ""
  switchLanguageURL: string = ""
  showSearchBar: boolean = false

  showLoginButtons: boolean = false
  showHaveARestaurantButton: boolean = false
  userLoggedIn: boolean = false
  customerLoggedIn: boolean = false
  logoImageURL: string = ""
  isSmallScreen: boolean = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    protected readonly apiClient: BaseApiService,
    private accountAPI: AccountApi,
    private breakpointObserver: BreakpointObserver,
    private merchantLoginService: MerchantLoginService,
    private appNavigator: AppNavigator,
    private redirectService: RedirectService,
    private authService: AuthService
  ) {
    this.refreshToken()
    // if (this.apiClient.getJwt()) {
    //   this.apiClient.refreshToken().subscribe({
    //     error: error => {
    //       // Try to refresh token if it exists
    //       if (error.status === 401) {
    //         this.apiClient.clearJWTToken()
    //         this.userLoggedIn = false
    //         this.customerLoggedIn = false
    //       }
    //     }
    //   });
    // } else {
    //   this.userLoggedIn = false
    //   this.customerLoggedIn = false
    // }
  }

  ngOnInit(): void {
    // console.log("window.location.href = " + window.location.href)
    // console.log("window.location.protocol = " + window.location.protocol)
    // console.log("window.location.host = " + window.location.host)
    // console.log("window.location.pathname = " + window.location.pathname)
    // console.log("window.location.search = " + window.location.search)
    //
    // console.log("route.url = " + this.route.url)
    let pathName = window.location.pathname
    // console.log("router.url = " + this.router.url)
    if (pathName.startsWith('/ar/')) {
      this.switchLanguageName = 'EN'
      this.switchLanguageImageURL = "assets/merchant-landing-page/english-language-flag.svg";
    } else {
      this.switchLanguageName = 'ع'
      this.switchLanguageImageURL = "assets/merchant-landing-page/arabic-language-flag.svg";
    }

    this.setSwitchLanguageURL()
    this.manageRouterBasedConditions()
    this.isSmallScreen = window.innerWidth <= 768;
    this.setLogoImage()

    // Check the conditions when the page URL changes.
    this.router.events.subscribe(event => {
      this.setSwitchLanguageURL()
      this.manageRouterBasedConditions()
    });

    // Check conditions when the page size goes below 768.
    this.breakpointObserver.observe(['(max-width: 768px)'])
      .subscribe(result => {
        this.isSmallScreen = result.matches;
        this.setLogoImage()
      });

    this.reloadUserLogin()

    this.authService.authChange.subscribe(event => {
      // this.reloadUserLogin()
      this.manageRouterBasedConditions()
    });
  }


  refreshToken() {
    if (this.apiClient.getJwt()) {
      this.apiClient.refreshToken().subscribe({
        error: error => {
          // Try to refresh token if it exists
          if (error.status === 401) {
            this.apiClient.clearJWTToken()
            this.userLoggedIn = false
            this.customerLoggedIn = false
          }
        }
      });
    } else {
      this.userLoggedIn = false
      this.customerLoggedIn = false
    }
  }

  setLogoImage() {
    if (this.isSmallScreen) {
      if (this.showSearchBar)
        this.logoImageURL = LogoURLs.LOGO_ONLY
      else
        this.logoImageURL = LogoURLs.FULL_LOGO
    } else
      this.logoImageURL = LogoURLs.FULL_LOGO
  }

  setSwitchLanguageURL() {
    // console.log("window.location.href = " + window.location.href)
    // console.log("window.location.protocol = " + window.location.protocol)
    // console.log("window.location.host = " + window.location.host)
    // console.log("window.location.pathname = " + window.location.pathname)
    // console.log("window.location.search = " + window.location.search)

    let pathName = window.location.pathname
    // console.log("router.url = " + this.router.url)
    if (pathName.startsWith('/ar/')) {
      this.switchLanguageURL = window.location.protocol + "//" + window.location.host + pathName.slice(3); // 3 characters: /ar
    } else {
      this.switchLanguageURL = window.location.protocol + "//" + window.location.host + "/ar" + pathName;
    }
  }

  reloadUserLogin() {
    // Show login buttons on merchants pages only and hide "Have a restaurant otherwise"
    this.userLoggedIn = this.authService.getUser() != null;
    this.customerLoggedIn = this.authService.geCustomer() != null;
  }

  manageRouterBasedConditions() {
    this.reloadUserLogin()
    // this.showLoginButtons = this.router.url.includes("/merchants") && !this.userLoggedIn;
    if (!this.router.url.includes("/merchants")) {
      this.showLoginButtons = !this.customerLoggedIn
      this.headerState = AppHeaderStates.customer
    } else {
      this.headerState = AppHeaderStates.merchant
      this.showLoginButtons = !this.userLoggedIn;
    }

    this.showHaveARestaurantButton = !this.router.url.includes("/merchants");
    this.showSearchBar = !(this.router.url === "/" || this.router.url.includes("/restaurants"));
    if (this.router.url.includes("/login")) {
      this.showLoginButtons = false
    }
  }

  signUp() {
    this.router.navigate(['signup'])
  }

  goToMerchantPortal() {
    this.apiClient.refreshToken().subscribe({
      next: () => this.merchantLoginService.redirectToLogin(this.apiClient.getJwt()),
      error: error => {
        // error.
        if (error.status === 401) {
          this.apiClient.clearJWTToken()
          this.appNavigator.navigateTo({ target: NavigatorTarget.merchantLogin })
        }
        console.log(error.status)
      }
    });
  }

  logout() {
    // this.userLoggedIn = false
    this.accountAPI.logout().subscribe(() => {
      if (this.router.url.startsWith("/merchants/signup/more-info") || this.router.url.startsWith("/merchants/signup/contact-info")) {
        this.router.navigate(["/merchants/signup/login"])
      }

      this.manageRouterBasedConditions()
    });
  }

  isUserMerchant(): boolean {
  return   this.authService.isUserMerchant()
  }

  isCustomerLoggedIn(): boolean {
    const jwt = this.apiClient.getJwt()
    return !!(jwt && jwt.customer)
  }

  getLoginRoute() {
    if (this.headerState === AppHeaderStates.customer) {
      return { data: 'customer' }
    } else {
      return { data: 'merchant' }
    }
  }

  onLoginClick() {
    if (this.headerState === AppHeaderStates.customer) {
      let currentPage = this.router.url;
      this.redirectService.setRedirectUrl(currentPage);
    }
  }


  getSignUpRoute(): string {
    if (this.headerState === AppHeaderStates.customer) {
      return '/customers/signup'
    } else {
      return '/merchants/signup'
    }
  }

  getUsername(): string {
    if (this.customerLoggedIn) {
      return this.authService.geCustomer()?.name ?? ""
    } else if (this.userLoggedIn) {
      return this.authService.getUser()?.name ?? ""
    } else {
      return ""
    }
  }

}
